/**
 * Extract initials from a full name.
 * Takes the first letter of the first and last name parts.
 * Examples: "Jan Erik Hansen" → "JH", "Maria Olsen" → "MO", "Thomas" → "T"
 */
export const getInitials = (name: string | null | undefined): string => {
    if (!name || !name.trim()) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
